/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2020
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import BaseMoserObject from './BaseMoserObject';
import Index from './Index';
import ForeignKey from './ForeignKey';
import QuerySubject from './QuerySubject';
import SecurityFilter from './SecurityFilter';
import Relationship from './Relationship';
import ParameterMap from './ParameterMap';
import DrillGroup from './DrillGroup';
import QueryValueSelector from './QueryValueSelector';
import Module from './Module';
import ReferenceResolver from './ReferenceResolver';
import ValidationMessage from './ValidationMessage';
import Feedback from './Feedback';
import ItemNormalizationGroupType from './ItemNormalizationGroupType';
import TextResource from './TextResource';
import SortListType from './SortListType';
import ItemType from './ItemType';
import FacetType from './FacetType';
import DataSource from './DataSource';
import PhysicalObjectType from './PhysicalObjectType';
import BaseObjectType from './BaseObjectType';
import PropertyType from './PropertyType';
import Jdbc from './Jdbc';
import Table from './Table';
import Column from './Column';
import PrimaryKey from './PrimaryKey';
import TableItemType from './TableItemType';
import StoredProcedure from './StoredProcedure';
import ProcParameterType from './ProcParameterType';
import DbFunction from './DbFunction';
import Struct from './Struct';
import Multiset from './Multiset';
import ObjectType from './ObjectType';
import QueryItem from './QueryItem';
import TaxonomyType from './TaxonomyType';
import SplitType from './SplitType';
import PromptInfoType from './PromptInfoType';
import CalculatedMemberType from './CalculatedMemberType';
import MemberType from './MemberType';
import Filter from './Filter';
import SqlQueryType from './SqlQueryType';
import ItemNormalizationType from './ItemNormalizationType';
import NamedSet from './NamedSet';
import CardinalityType from './CardinalityType';
import Calculation from './Calculation';
import ItemHierarchy from './ItemHierarchy';
import LocalRefType from './LocalRefType';
import ParameterValueSet from './ParameterValueSet';
import ParameterValue from './ParameterValue';
import ValueType from './ValueType';
import ParameterFault from './ParameterFault';
import ParameterCapabilitiesType from './ParameterCapabilitiesType';
import Prompt from './Prompt';
import ParameterFeedbackInfo from './ParameterFeedbackInfo';
import FolderType from './FolderType';
import Focus from './Focus';
import SplitRule from './SplitRule';
import SplitConfig from './SplitConfig';
import ProjectedItemType from './ProjectedItemType';
import FolderItemType from './FolderItemType';
import DefLinkType from './DefLinkType';
//@import BaseMoserObject (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/generated/metadata/Index (runtime) // fromJSON, Index
//@import com/ibm/bi/platform/moser/common/generated/metadata/ForeignKey (runtime) // fromJSON, ForeignKey
//@import com/ibm/bi/platform/moser/common/generated/metadata/QuerySubject (runtime) // fromJSON, QuerySubject
//@import com/ibm/bi/platform/moser/common/generated/metadata/SecurityFilter (runtime) // SecurityFilter, fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/Relationship (runtime) // Relationship, fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/ParameterMap (runtime) // fromJSON, ParameterMap
//@import com/ibm/bi/platform/moser/common/generated/metadata/DrillGroup (runtime) // DrillGroup, fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/QueryValueSelector (runtime) // fromJSON, QueryValueSelector
//@import com/ibm/bi/platform/moser/common/generated/metadata/Module (runtime) // fromJSON, Module
//@import com/ibm/bi/platform/moser/common/utils/ReferenceResolver (runtime) // resolve
//@import com/ibm/bi/platform/moser/common/generated/metadata/ValidationMessage (runtime) // ValidationMessage, fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/Feedback (runtime) // Feedback, fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/ItemNormalizationGroupType (runtime) // fromJSON, ItemNormalizationGroupType
//@import com/ibm/bi/platform/moser/common/generated/metadata/TextResource (runtime) // TextResource, fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/SortListType (runtime) // fromJSON, SortListType
//@import com/ibm/bi/platform/moser/common/generated/metadata/ItemType (runtime) // ItemType, fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/FacetType (runtime) // FacetType, fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/DataSource (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/PhysicalObjectType (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/BaseObjectType (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/PropertyType (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/Jdbc (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/Table (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/Column (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/PrimaryKey (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/TableItemType (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/StoredProcedure (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/ProcParameterType (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/DbFunction (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/Struct (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/Multiset (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/QueryItem (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/TaxonomyType (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/SplitType (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/PromptInfoType (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/CalculatedMemberType (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/MemberType (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/Filter (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/SqlQueryType (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/ItemNormalizationType (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/NamedSet (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/CardinalityType (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/Calculation (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/ItemHierarchy (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/LocalRefType (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/ParameterValueSet (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/ParameterValue (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/ValueType (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/ParameterFault (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/ParameterCapabilitiesType (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/Prompt (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/ParameterFeedbackInfo (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/FolderType (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/Focus (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/SplitRule (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/SplitConfig (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/ProjectedItemType (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/FolderItemType (runtime) // fromJSON
//@import com/ibm/bi/platform/moser/common/generated/metadata/DefLinkType (runtime) // fromJSON

/**
 * This object contains factory methods for each  Java content interface and Java element interface  generated in the com.ibm.bi.platform.moser.client.generated.metadata package.  <p>An JSONObjectFactory allows you to programmatically  construct new instances of the Java representation  for XML content from a JOSN object. The Java representation of XML  content can consist of schema derived interfaces  and classes representing the binding of schema  type definitions, element declarations and model  groups.  Factory methods for each of these are  provided in this class.
 */
export default class JSONObjectFactory extends BaseMoserObject{

	_objectFactory = null;



	constructor(objectFactory) {
		super();
		this._objectFactory = objectFactory;
	}

	/**
	 * Creates a new instance of <code>Index</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> Index</code> object.
	 * @return {Index} an object of type <code>Index</code>
	 */
	createIndex(json) {
		return Index.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>ForeignKey</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> ForeignKey</code> object.
	 * @return {ForeignKey} an object of type <code>ForeignKey</code>
	 */
	createForeignKey(json) {
		return ForeignKey.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>QuerySubject</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> QuerySubject</code> object.
	 * @return {QuerySubject} an object of type <code>QuerySubject</code>
	 */
	createQuerySubject(json) {
		return QuerySubject.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>SecurityFilter</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> SecurityFilter</code> object.
	 * @return {SecurityFilter} an object of type <code>SecurityFilter</code>
	 */
	createSecurityFilter(json) {
		return SecurityFilter.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>Relationship</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> Relationship</code> object.
	 * @return {Relationship} an object of type <code>Relationship</code>
	 */
	createRelationship(json) {
		return Relationship.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>ParameterMap</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> ParameterMap</code> object.
	 * @return {ParameterMap} an object of type <code>ParameterMap</code>
	 */
	createParameterMap(json) {
		return ParameterMap.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>DrillGroup</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> DrillGroup</code> object.
	 * @return {DrillGroup} an object of type <code>DrillGroup</code>
	 */
	createDrillGroup(json) {
		return DrillGroup.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>QueryValueSelector</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> QueryValueSelector</code> object.
	 * @return {QueryValueSelector} an object of type <code>QueryValueSelector</code>
	 */
	createQueryValueSelector(json) {
		return QueryValueSelector.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>Module</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> Module</code> object.
	 * @return {Module} an object of type <code>Module</code>
	 */
	createModule(json) {
		var module = Module.fromJSON(json, this._objectFactory);
		module.setOverrideMode(true);
		ReferenceResolver.resolve(module);
		return module;
	}

	/**
	 * Creates a new instance of <code>ValidationMessage</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> ValidationMessage</code> object.
	 * @return {ValidationMessage} an object of type <code>ValidationMessage</code>
	 */
	createValidationMessage(json) {
		return ValidationMessage.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>Feedback</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> Feedback</code> object.
	 * @return {Feedback} an object of type <code>Feedback</code>
	 */
	createFeedback(json) {
		return Feedback.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>ItemNormalizationGroupType</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> ItemNormalizationGroupType</code> object.
	 * @return {ItemNormalizationGroupType} an object of type <code>ItemNormalizationGroupType</code>
	 */
	createItemNormalizationGroupType(json) {
		return ItemNormalizationGroupType.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>TextResource</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> TextResource</code> object.
	 * @return {TextResource} an object of type <code>TextResource</code>
	 */
	createTextResource(json) {
		return TextResource.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>UseSpec</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> UseSpec</code> object.
	 * @return {UseSpec} an object of type <code>UseSpec</code>
	 */
	createModuleUseSpec(json) {
		return Module.UseSpec.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>SortListType</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> SortListType</code> object.
	 * @return {SortListType} an object of type <code>SortListType</code>
	 */
	createSortListType(json) {
		return SortListType.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>ItemType</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> ItemType</code> object.
	 * @return {ItemType} an object of type <code>ItemType</code>
	 */
	createItemType(json) {
		return ItemType.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>FacetType</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> FacetType</code> object.
	 * @return {FacetType} an object of type <code>FacetType</code>
	 */
	createFacetType(json) {
		return FacetType.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>DataSource</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> DataSource</code> object.
	 * @return {DataSource} an object of type <code>DataSource</code>
	 */
	createDataSource(json) {
		return DataSource.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>PhysicalObjectType</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> PhysicalObjectType</code> object.
	 * @return {PhysicalObjectType} an object of type <code>PhysicalObjectType</code>
	 */
	createPhysicalObjectType(json) {
		return PhysicalObjectType.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>BaseObjectType</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> BaseObjectType</code> object.
	 * @return {BaseObjectType} an object of type <code>BaseObjectType</code>
	 */
	createBaseObjectType(json) {
		return BaseObjectType.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>PropertyType</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> PropertyType</code> object.
	 * @return {PropertyType} an object of type <code>PropertyType</code>
	 */
	createPropertyType(json) {
		return PropertyType.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>Jdbc</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> Jdbc</code> object.
	 * @return {Jdbc} an object of type <code>Jdbc</code>
	 */
	createJdbc(json) {
		return Jdbc.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>Table</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> Table</code> object.
	 * @return {Table} an object of type <code>Table</code>
	 */
	createTable(json) {
		return Table.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>Column</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> Column</code> object.
	 * @return {Column} an object of type <code>Column</code>
	 */
	createColumn(json) {
		return Column.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>IndexedColumn</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> IndexedColumn</code> object.
	 * @return {IndexedColumn} an object of type <code>IndexedColumn</code>
	 */
	createIndexIndexedColumn(json) {
		return Index.IndexedColumn.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>PrimaryKey</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> PrimaryKey</code> object.
	 * @return {PrimaryKey} an object of type <code>PrimaryKey</code>
	 */
	createPrimaryKey(json) {
		return PrimaryKey.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>FkColumn</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> FkColumn</code> object.
	 * @return {FkColumn} an object of type <code>FkColumn</code>
	 */
	createForeignKeyFkColumn(json) {
		return ForeignKey.FkColumn.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>TableItemType</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> TableItemType</code> object.
	 * @return {TableItemType} an object of type <code>TableItemType</code>
	 */
	createTableItemType(json) {
		return TableItemType.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>StoredProcedure</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> StoredProcedure</code> object.
	 * @return {StoredProcedure} an object of type <code>StoredProcedure</code>
	 */
	createStoredProcedure(json) {
		return StoredProcedure.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>ProcParameterType</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> ProcParameterType</code> object.
	 * @return {ProcParameterType} an object of type <code>ProcParameterType</code>
	 */
	createProcParameterType(json) {
		return ProcParameterType.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>DbFunction</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> DbFunction</code> object.
	 * @return {DbFunction} an object of type <code>DbFunction</code>
	 */
	createDbFunction(json) {
		return DbFunction.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>Struct</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> Struct</code> object.
	 * @return {Struct} an object of type <code>Struct</code>
	 */
	createStruct(json) {
		return Struct.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>Multiset</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> Multiset</code> object.
	 * @return {Multiset} an object of type <code>Multiset</code>
	 */
	createMultiset(json) {
		return Multiset.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>ObjectType</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> ObjectType</code> object.
	 * @return {ObjectType} an object of type <code>ObjectType</code>
	 */
	createObjectType(json) {
		return ObjectType.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>ColumnDependency</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> ColumnDependency</code> object.
	 * @return {ColumnDependency} an object of type <code>ColumnDependency</code>
	 */
	createQuerySubjectColumnDependency(json) {
		return QuerySubject.ColumnDependency.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>QueryItem</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> QueryItem</code> object.
	 * @return {QueryItem} an object of type <code>QueryItem</code>
	 */
	createQueryItem(json) {
		return QueryItem.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>TaxonomyType</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> TaxonomyType</code> object.
	 * @return {TaxonomyType} an object of type <code>TaxonomyType</code>
	 */
	createTaxonomyType(json) {
		return TaxonomyType.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>SplitType</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> SplitType</code> object.
	 * @return {SplitType} an object of type <code>SplitType</code>
	 */
	createSplitType(json) {
		return SplitType.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>PromptInfoType</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> PromptInfoType</code> object.
	 * @return {PromptInfoType} an object of type <code>PromptInfoType</code>
	 */
	createPromptInfoType(json) {
		return PromptInfoType.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>CalculatedMemberType</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> CalculatedMemberType</code> object.
	 * @return {CalculatedMemberType} an object of type <code>CalculatedMemberType</code>
	 */
	createCalculatedMemberType(json) {
		return CalculatedMemberType.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>MemberType</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> MemberType</code> object.
	 * @return {MemberType} an object of type <code>MemberType</code>
	 */
	createMemberType(json) {
		return MemberType.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>Filter</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> Filter</code> object.
	 * @return {Filter} an object of type <code>Filter</code>
	 */
	createFilter(json) {
		return Filter.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>SqlQueryType</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> SqlQueryType</code> object.
	 * @return {SqlQueryType} an object of type <code>SqlQueryType</code>
	 */
	createSqlQueryType(json) {
		return SqlQueryType.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>QueryOperation</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> QueryOperation</code> object.
	 * @return {QueryOperation} an object of type <code>QueryOperation</code>
	 */
	createQuerySubjectQueryOperation(json) {
		return QuerySubject.QueryOperation.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>JoinOperation</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> JoinOperation</code> object.
	 * @return {JoinOperation} an object of type <code>JoinOperation</code>
	 */
	createQuerySubjectJoinOperation(json) {
		return QuerySubject.JoinOperation.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>ItemNormalizationType</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> ItemNormalizationType</code> object.
	 * @return {ItemNormalizationType} an object of type <code>ItemNormalizationType</code>
	 */
	createItemNormalizationType(json) {
		return ItemNormalizationType.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>SecurityObject</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> SecurityObject</code> object.
	 * @return {SecurityObject} an object of type <code>SecurityObject</code>
	 */
	createSecurityFilterSecurityObject(json) {
		return SecurityFilter.SecurityObject.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>NamedSet</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> NamedSet</code> object.
	 * @return {NamedSet} an object of type <code>NamedSet</code>
	 */
	createNamedSet(json) {
		return NamedSet.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>CardinalityType</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> CardinalityType</code> object.
	 * @return {CardinalityType} an object of type <code>CardinalityType</code>
	 */
	createCardinalityType(json) {
		return CardinalityType.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>Link</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> Link</code> object.
	 * @return {Link} an object of type <code>Link</code>
	 */
	createRelationshipLink(json) {
		return Relationship.Link.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>ParameterMapEntry</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> ParameterMapEntry</code> object.
	 * @return {ParameterMapEntry} an object of type <code>ParameterMapEntry</code>
	 */
	createParameterMapParameterMapEntry(json) {
		return ParameterMap.ParameterMapEntry.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>QueryItemMap</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> QueryItemMap</code> object.
	 * @return {QueryItemMap} an object of type <code>QueryItemMap</code>
	 */
	createParameterMapQueryItemMap(json) {
		return ParameterMap.QueryItemMap.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>Calculation</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> Calculation</code> object.
	 * @return {Calculation} an object of type <code>Calculation</code>
	 */
	createCalculation(json) {
		return Calculation.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>Segment</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> Segment</code> object.
	 * @return {Segment} an object of type <code>Segment</code>
	 */
	createDrillGroupSegment(json) {
		return DrillGroup.Segment.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>ItemHierarchy</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> ItemHierarchy</code> object.
	 * @return {ItemHierarchy} an object of type <code>ItemHierarchy</code>
	 */
	createItemHierarchy(json) {
		return ItemHierarchy.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>LocalRefType</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> LocalRefType</code> object.
	 * @return {LocalRefType} an object of type <code>LocalRefType</code>
	 */
	createLocalRefType(json) {
		return LocalRefType.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>ParameterValueSet</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> ParameterValueSet</code> object.
	 * @return {ParameterValueSet} an object of type <code>ParameterValueSet</code>
	 */
	createParameterValueSet(json) {
		return ParameterValueSet.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>ParameterValue</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> ParameterValue</code> object.
	 * @return {ParameterValue} an object of type <code>ParameterValue</code>
	 */
	createParameterValue(json) {
		return ParameterValue.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>ValueType</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> ValueType</code> object.
	 * @return {ValueType} an object of type <code>ValueType</code>
	 */
	createValueType(json) {
		return ValueType.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>ParameterFault</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> ParameterFault</code> object.
	 * @return {ParameterFault} an object of type <code>ParameterFault</code>
	 */
	createParameterFault(json) {
		return ParameterFault.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>ParameterCapabilitiesType</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> ParameterCapabilitiesType</code> object.
	 * @return {ParameterCapabilitiesType} an object of type <code>ParameterCapabilitiesType</code>
	 */
	createParameterCapabilitiesType(json) {
		return ParameterCapabilitiesType.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>Prompt</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> Prompt</code> object.
	 * @return {Prompt} an object of type <code>Prompt</code>
	 */
	createPrompt(json) {
		return Prompt.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>SortExpression</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> SortExpression</code> object.
	 * @return {SortExpression} an object of type <code>SortExpression</code>
	 */
	createQueryValueSelectorSortExpression(json) {
		return QueryValueSelector.SortExpression.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>ParameterFeedbackInfo</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> ParameterFeedbackInfo</code> object.
	 * @return {ParameterFeedbackInfo} an object of type <code>ParameterFeedbackInfo</code>
	 */
	createParameterFeedbackInfo(json) {
		return ParameterFeedbackInfo.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>FolderType</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> FolderType</code> object.
	 * @return {FolderType} an object of type <code>FolderType</code>
	 */
	createFolderType(json) {
		return FolderType.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>Focus</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> Focus</code> object.
	 * @return {Focus} an object of type <code>Focus</code>
	 */
	createFocus(json) {
		return Focus.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>ErrorData</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> ErrorData</code> object.
	 * @return {ErrorData} an object of type <code>ErrorData</code>
	 */
	createValidationMessageErrorData(json) {
		return ValidationMessage.ErrorData.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>Data</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> Data</code> object.
	 * @return {Data} an object of type <code>Data</code>
	 */
	createFeedbackData(json) {
		return Feedback.Data.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>Msg</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> Msg</code> object.
	 * @return {Msg} an object of type <code>Msg</code>
	 */
	createFeedbackMsg(json) {
		return Feedback.Msg.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>SplitRule</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> SplitRule</code> object.
	 * @return {SplitRule} an object of type <code>SplitRule</code>
	 */
	createSplitRule(json) {
		return SplitRule.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>SplitConfig</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> SplitConfig</code> object.
	 * @return {SplitConfig} an object of type <code>SplitConfig</code>
	 */
	createSplitConfig(json) {
		return SplitConfig.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>ProjectedItemType</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> ProjectedItemType</code> object.
	 * @return {ProjectedItemType} an object of type <code>ProjectedItemType</code>
	 */
	createProjectedItemType(json) {
		return ProjectedItemType.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>FolderItemType</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> FolderItemType</code> object.
	 * @return {FolderItemType} an object of type <code>FolderItemType</code>
	 */
	createFolderItemType(json) {
		return FolderItemType.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>DefLinkType</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> DefLinkType</code> object.
	 * @return {DefLinkType} an object of type <code>DefLinkType</code>
	 */
	createDefLinkType(json) {
		return DefLinkType.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>Key</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> Key</code> object.
	 * @return {Key} an object of type <code>Key</code>
	 */
	createItemNormalizationGroupTypeKey(json) {
		return ItemNormalizationGroupType.Key.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>Attribute</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> Attribute</code> object.
	 * @return {Attribute} an object of type <code>Attribute</code>
	 */
	createItemNormalizationGroupTypeAttribute(json) {
		return ItemNormalizationGroupType.Attribute.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>Item</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> Item</code> object.
	 * @return {Item} an object of type <code>Item</code>
	 */
	createTextResourceItem(json) {
		return TextResource.Item.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>Ancestors</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> Ancestors</code> object.
	 * @return {Ancestors} an object of type <code>Ancestors</code>
	 */
	createModuleUseSpecAncestors(json) {
		return Module.UseSpec.Ancestors.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>SortItem</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> SortItem</code> object.
	 * @return {SortItem} an object of type <code>SortItem</code>
	 */
	createSortListTypeSortItem(json) {
		return SortListType.SortItem.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>Folder</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> Folder</code> object.
	 * @return {Folder} an object of type <code>Folder</code>
	 */
	createItemTypeFolder(json) {
		return ItemType.Folder.fromJSON(json, this._objectFactory);
	}

	/**
	 * Creates a new instance of <code>Context</code> object from JSON data and notifies all registered listeners with a create event.
	 * @param {Object} json JSON data to be used to create the <code> Context</code> object.
	 * @return {Context} an object of type <code>Context</code>
	 */
	createFacetTypeContext(json) {
		return FacetType.Context.fromJSON(json, this._objectFactory);
	}
}


// WEBPACK FOOTER //
// ./src/generated/JSONObjectFactory.js